import React, { FC } from 'react';
import moment from 'moment';
import { Link } from '@material-ui/core';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

import { Content } from 'api';
import { generateLink } from 'Links';

const styles = () =>
  createStyles({
    root: {
      display: 'inline-block',
    },
  });

interface IProps extends WithStyles<typeof styles> {
  contentId: Content['content_id'];
  publishAt: Content['publish_at'];
}

const Date: FC<IProps> = ({ classes, contentId, publishAt }) => (
  <Link
    component={generateLink(`/content/${contentId}`)}
    className={classes.root}
    color="textSecondary">
    {moment.unix(publishAt).fromNow()}
  </Link>
);

export default withStyles(styles)(Date);
